module.exports = __webpack_public_path__ + "img/turk-nippon-sigorta.0963cae1.jpg";